{
  document.addEventListener("DOMContentLoaded", () => {
    const marquee = document.querySelector(".LoopMarque");
    if (!marquee) return;

    const originalItems = [...marquee.querySelectorAll(".slider__item")];
    if (!originalItems.length) return;

    const setupMarquee = () => {
      // Remove previous clones
      marquee.querySelectorAll(".marquee-clone").forEach((el) => el.remove());

      // Kill previous animation
      if (marquee._marqueeAnimation) {
        marquee._marqueeAnimation.kill();
      }

      // Calculate original items width
      const itemsWidth = originalItems.reduce(
        (total, item) => total + item.offsetWidth,
        0
      );

      if (!itemsWidth) return;

      const screenWidth = window.innerWidth;

      // How many copies are needed to fill the screen
      const copies = Math.ceil(screenWidth / itemsWidth) + 2;

      // Duplicate original items
      for (let i = 0; i < copies; i++) {
        originalItems.forEach((item) => {
          const clone = item.cloneNode(true);
          clone.classList.add("marquee-clone");
          marquee.appendChild(clone);
        });
      }

      // Width of one complete original set
      const distance = itemsWidth;

      // GSAP animation
      const animation = gsap.to(marquee, {
        x: -distance,
        duration: distance / 50,
        ease: "none",
        repeat: -1,
      });

      marquee._marqueeAnimation = animation;

      // Pause on mouse hover
      marquee.addEventListener("mouseenter", () => {
        animation.pause();
      });

      marquee.addEventListener("mouseleave", () => {
        animation.resume();
      });
    };

    setupMarquee();

    // Recalculate on resize
    let resizeTimer;

    window.addEventListener("resize", () => {
      clearTimeout(resizeTimer);

      resizeTimer = setTimeout(() => {
        setupMarquee();
      }, 300);
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".Banner_Slider");
  const prevArrow = slider.parentElement.querySelector(".prev");
  const nextArrow = slider.parentElement.querySelector(".next");
  const swiper = new Swiper(".Banner_Slider", {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    direction: "horizontal",
    grabCursor: true,
    speed: 1000,
    parallax: true,
    navigation: {
      nextEl: nextArrow,
      prevEl: prevArrow,
    },
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const MultipleSlider = () => {
    const MultipleSliders = document.querySelectorAll(".catgSlider");
    MultipleSliders.forEach((slider, index) => {
      const prevArrow = slider.parentElement.querySelector(
        ".swiper-button-prev",
      );
      const nextArrow = slider.parentElement.querySelector(
        ".swiper-button-next",
      );
      new Swiper(slider, {
        direction: "horizontal",
        speed: 1000,
        navigation: {
          nextEl: nextArrow,
          prevEl: prevArrow,
        },
        breakpoints: {
          150: {
            slidesPerView: 1.5,
            spaceBetween: 10,
          },
          576: {
            slidesPerView: 2.5,
            spaceBetween: 10,
          },
          769: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1025: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
        },
      });
    });
  };
  MultipleSlider();
});

document.addEventListener("DOMContentLoaded", function () {
  const MultipleSlider = () => {
    const MultipleSliders = document.querySelectorAll(".testimonialSlider");

    MultipleSliders.forEach((slider) => {
      const prevArrow = slider.parentElement.querySelector(
        ".swiper-button-prev",
      );
      const nextArrow = slider.parentElement.querySelector(
        ".swiper-button-next",
      );
      new Swiper(slider, {
        direction: "horizontal",
        // loop: true,
        speed: 800,
        // autoplay: {
        //   delay: 2500,
        //   disableOnInteraction: false,
        //   pauseOnMouseEnter: true,
        // },

        navigation: {
          nextEl: nextArrow,
          prevEl: prevArrow,
        },

        breakpoints: {
          150: {
            slidesPerView: 1.5,
            spaceBetween: 10,
          },
          576: {
            slidesPerView: 2.2,
            spaceBetween: 10,
          },
          769: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1025: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
        },
      });
    });
  };

  MultipleSlider();
});
